'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('groupSection', {
                parent: 'entity',
                url: '/groupSections',
                data: {
                    role: ['ROLE_TUTOR'],
                    pageTitle: 'lmsApp.videoconfconfig.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupSection/groupSections.html',
                        controller: 'groupSectionController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('userGroup');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sectionsInGroup', {
                parent: 'entity',
                url: '/groupSections/sections/:id',
                data: {
                    role: ['ROLE_TUTOR'],
                    pageTitle: 'lmsApp.videoconfconfig.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupSection/sectionsInGroup.html',
                        controller: 'sectionsInGroupController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('courseSection');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sectionsInGroupDetail', {
                parent: 'entity',
                url: '/groupSections/:id',
                data: {
                    role: ['ROLE_TUTOR'],
                    pageTitle: 'lmsApp.courseSection.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupSection/sectionsInGroup-detail.html',
                        controller: 'sectionsInGroupDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('courseSection');
                        return $translate.refresh();
                    }]
                }
            });
    });
